export default "__VITE_ASSET__voO6Kw6l__"